export *  from "./getNameChar"
export *  from "./exportDataBattle"
export *  from "./importDataBattle"